module.exports = __webpack_public_path__ + "static/4-uk-muslim-woman-fef19d1a0a23db03c17c18a704f98dd6.jpg";